let _callback: (() => void) | null = null;

export function setNpsCompletionCallback(cb: () => void) {
  _callback = cb;
}

export function clearNpsCompletionCallback() {
  _callback = null;
}

export function runAndClearNpsCallback() {
  const cb = _callback;
  _callback = null;
  if (cb) cb();
}
